import {
    FETCH_ORG_RATER_GROUPS_START,
    FETCH_ORG_RATER_GROUPS_SUCCESS,
    FETCH_ORG_RATER_GROUPS_FAIL

} from "../../../constants";
import {
    FETCH_ORG_RATER_GROUPS_URL,
} from "../../../../../config/constants";
import { ApiBase } from "../../../../utils/apiBase";
import { withType } from "../../../../utils/actionOperations";
import { getProjectIdAndOrgId } from '../../../../utils/apiUtils';
import { SETTINGS_PAGE_SECTION } from "../../../../../config/tabConstants";

export const getOrgRaterGroups = (payload, cb) => {
    const apiBaseInstance = new ApiBase().instance;
    return (dispatch) => {
        dispatch(
            withType(FETCH_ORG_RATER_GROUPS_START, { ...payload })
        );
        return apiBaseInstance
            .post(FETCH_ORG_RATER_GROUPS_URL, {
                ...payload, ...getProjectIdAndOrgId(payload), currentTab: SETTINGS_PAGE_SECTION.SETTINGS_SUB_TABS.ADMINISTRATOR
            })
            .then((res) => {
                dispatch(
                    withType(FETCH_ORG_RATER_GROUPS_SUCCESS, {
                        data: res.data,
                        payload: payload
                    })
                );
                cb && cb(true, res.data)
            })
            .catch((err) => {
                dispatch(withType(FETCH_ORG_RATER_GROUPS_FAIL, { ...err, ...payload }));
                cb && cb(false)
            });
    };
};
